import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Text, Icon } from '../../components';
import { colors } from '../../theme';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const DocketDetailItem = ({
	onPress,
	label,
	warning,
	subLabel,
	subText,
	subTextAsWarning,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<TouchableOpacity style={styles.machineDetailItem} onPress={onPress}>
			<View style={{ flexDirection: 'column', flex: 10 }}>
				<View style={{ flexDirection: 'row', alignItems: 'center' }}>
					<Text style={styles.labelText}>
						{label}
					</Text>
				</View>

				<View style={{ flexDirection: 'row' }}>
					{warning && (
						<Icon
							name="exclamationCircle"
							size={14}
							color={colors.RED[3]}
							style={{ marginRight: 4 }}
						/>
					)}
					{subLabel ? (
						<Text style={[styles.subLabelText, warning && styles.warningText]}>
							{subLabel}
						</Text>
					) : null}
				</View>
				<View>
					{subText && (
						<Text style={[styles.subText, (warning || subTextAsWarning) && styles.warningText]}>
							{subText}
						</Text>
					)}
				</View>
			</View>
			<View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
				<Icon name="arrowRight" size={24} color={styles.arrowIcon.color} />
			</View>
		</TouchableOpacity>
	);
};

const createStyles = (theme) => ({
	machineDetailItem: {
		flex: 1,
		backgroundColor: theme.mainBg1,
		padding: 8,
		borderColor: theme.border3,
		borderBottomWidth: 1,
		flexDirection: 'row',
	},
	labelText: {
		fontSize: 20,
		color: theme.text1,
	},
	subLabelText: {
		color: theme.text2,
	},
	subText: {
		color: theme.text2,
	},
	warningText: {
		color: colors.RED[3],
	},
	arrowIcon: {
		color: theme.text3,
	},
});


export default React.memo(DocketDetailItem);
